/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.MsgData = (function() {

    /**
     * Properties of a MsgData.
     * @exports IMsgData
     * @interface IMsgData
     * @property {string|null} [guid] MsgData guid
     * @property {string|null} [packageGuid] MsgData packageGuid
     * @property {number|null} [version] MsgData version
     * @property {string|null} [fromGuid] MsgData fromGuid
     * @property {string|null} [targetGuid] MsgData targetGuid
     * @property {number|Long|null} [time] MsgData time
     * @property {string|null} [data] MsgData data
     * @property {MsgData.SessionType|null} [sessionType] MsgData sessionType
     * @property {MsgData.ContentType|null} [contentType] MsgData contentType
     * @property {MsgData.ReadyState|null} [readyState] MsgData readyState
     * @property {MsgData.Sender|null} [sender] MsgData sender
     * @property {string|null} [extension] MsgData extension
     * @property {string|null} [actions] MsgData actions
     * @property {MsgData.ReadStatus|null} [readStatus] MsgData readStatus
     */

    /**
     * Constructs a new MsgData.
     * @exports MsgData
     * @classdesc Represents a MsgData.
     * @implements IMsgData
     * @constructor
     * @param {IMsgData=} [properties] Properties to set
     */
    function MsgData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MsgData guid.
     * @member {string} guid
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.guid = "";

    /**
     * MsgData packageGuid.
     * @member {string} packageGuid
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.packageGuid = "";

    /**
     * MsgData version.
     * @member {number} version
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.version = 0;

    /**
     * MsgData fromGuid.
     * @member {string} fromGuid
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.fromGuid = "";

    /**
     * MsgData targetGuid.
     * @member {string} targetGuid
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.targetGuid = "";

    /**
     * MsgData time.
     * @member {number|Long} time
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MsgData data.
     * @member {string} data
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.data = "";

    /**
     * MsgData sessionType.
     * @member {MsgData.SessionType} sessionType
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.sessionType = 0;

    /**
     * MsgData contentType.
     * @member {MsgData.ContentType} contentType
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.contentType = 0;

    /**
     * MsgData readyState.
     * @member {MsgData.ReadyState} readyState
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.readyState = 0;

    /**
     * MsgData sender.
     * @member {MsgData.Sender} sender
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.sender = 0;

    /**
     * MsgData extension.
     * @member {string} extension
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.extension = "";

    /**
     * MsgData actions.
     * @member {string} actions
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.actions = "";

    /**
     * MsgData readStatus.
     * @member {MsgData.ReadStatus} readStatus
     * @memberof MsgData
     * @instance
     */
    MsgData.prototype.readStatus = 0;

    /**
     * Creates a new MsgData instance using the specified properties.
     * @function create
     * @memberof MsgData
     * @static
     * @param {IMsgData=} [properties] Properties to set
     * @returns {MsgData} MsgData instance
     */
    MsgData.create = function create(properties) {
        return new MsgData(properties);
    };

    /**
     * Encodes the specified MsgData message. Does not implicitly {@link MsgData.verify|verify} messages.
     * @function encode
     * @memberof MsgData
     * @static
     * @param {IMsgData} message MsgData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MsgData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.packageGuid != null && message.hasOwnProperty("packageGuid"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.packageGuid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.version);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fromGuid);
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.targetGuid);
        if (message.time != null && message.hasOwnProperty("time"))
            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.time);
        if (message.data != null && message.hasOwnProperty("data"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.data);
        if (message.sessionType != null && message.hasOwnProperty("sessionType"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.sessionType);
        if (message.contentType != null && message.hasOwnProperty("contentType"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.contentType);
        if (message.readyState != null && message.hasOwnProperty("readyState"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.readyState);
        if (message.sender != null && message.hasOwnProperty("sender"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.sender);
        if (message.extension != null && message.hasOwnProperty("extension"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.extension);
        if (message.actions != null && message.hasOwnProperty("actions"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.actions);
        if (message.readStatus != null && message.hasOwnProperty("readStatus"))
            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.readStatus);
        return writer;
    };

    /**
     * Encodes the specified MsgData message, length delimited. Does not implicitly {@link MsgData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MsgData
     * @static
     * @param {IMsgData} message MsgData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MsgData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MsgData message from the specified reader or buffer.
     * @function decode
     * @memberof MsgData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MsgData} MsgData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MsgData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MsgData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.packageGuid = reader.string();
                break;
            case 3:
                message.version = reader.int32();
                break;
            case 4:
                message.fromGuid = reader.string();
                break;
            case 5:
                message.targetGuid = reader.string();
                break;
            case 6:
                message.time = reader.int64();
                break;
            case 7:
                message.data = reader.string();
                break;
            case 8:
                message.sessionType = reader.int32();
                break;
            case 9:
                message.contentType = reader.int32();
                break;
            case 10:
                message.readyState = reader.int32();
                break;
            case 11:
                message.sender = reader.int32();
                break;
            case 12:
                message.extension = reader.string();
                break;
            case 13:
                message.actions = reader.string();
                break;
            case 14:
                message.readStatus = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MsgData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MsgData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MsgData} MsgData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MsgData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MsgData message.
     * @function verify
     * @memberof MsgData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MsgData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.packageGuid != null && message.hasOwnProperty("packageGuid"))
            if (!$util.isString(message.packageGuid))
                return "packageGuid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            if (!$util.isString(message.targetGuid))
                return "targetGuid: string expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.sessionType != null && message.hasOwnProperty("sessionType"))
            switch (message.sessionType) {
            default:
                return "sessionType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.contentType != null && message.hasOwnProperty("contentType"))
            switch (message.contentType) {
            default:
                return "contentType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.readyState != null && message.hasOwnProperty("readyState"))
            switch (message.readyState) {
            default:
                return "readyState: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.sender != null && message.hasOwnProperty("sender"))
            switch (message.sender) {
            default:
                return "sender: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.extension != null && message.hasOwnProperty("extension"))
            if (!$util.isString(message.extension))
                return "extension: string expected";
        if (message.actions != null && message.hasOwnProperty("actions"))
            if (!$util.isString(message.actions))
                return "actions: string expected";
        if (message.readStatus != null && message.hasOwnProperty("readStatus"))
            switch (message.readStatus) {
            default:
                return "readStatus: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates a MsgData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MsgData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MsgData} MsgData
     */
    MsgData.fromObject = function fromObject(object) {
        if (object instanceof $root.MsgData)
            return object;
        var message = new $root.MsgData();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.packageGuid != null)
            message.packageGuid = String(object.packageGuid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.targetGuid != null)
            message.targetGuid = String(object.targetGuid);
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        if (object.data != null)
            message.data = String(object.data);
        switch (object.sessionType) {
        case "SESSION_UNKNOWN":
        case 0:
            message.sessionType = 0;
            break;
        case "P2P":
        case 1:
            message.sessionType = 1;
            break;
        case "SYSTEM":
        case 2:
            message.sessionType = 2;
            break;
        }
        switch (object.contentType) {
        case "CONTENT_UNKNOWN":
        case 0:
            message.contentType = 0;
            break;
        case "TEXT":
        case 1:
            message.contentType = 1;
            break;
        case "IMAGE":
        case 2:
            message.contentType = 2;
            break;
        case "ACC":
        case 3:
            message.contentType = 3;
            break;
        case "HOUSE":
        case 4:
            message.contentType = 4;
            break;
        case "ARTICLE":
        case 5:
            message.contentType = 5;
            break;
        case "ACTIONS":
        case 6:
            message.contentType = 6;
            break;
        case "CARD":
        case 7:
            message.contentType = 7;
            break;
        case "CARDTEXT":
        case 8:
            message.contentType = 8;
            break;
        }
        switch (object.readyState) {
        case "UNKNOWN":
        case 0:
            message.readyState = 0;
            break;
        case "READY":
        case 1:
            message.readyState = 1;
            break;
        case "NOT_READY":
        case 2:
            message.readyState = 2;
            break;
        }
        switch (object.sender) {
        case "SENDER_UNKNOWN":
        case 0:
            message.sender = 0;
            break;
        case "TO_AGENT":
        case 1:
            message.sender = 1;
            break;
        case "TO_CUSTOMER":
        case 2:
            message.sender = 2;
            break;
        }
        if (object.extension != null)
            message.extension = String(object.extension);
        if (object.actions != null)
            message.actions = String(object.actions);
        switch (object.readStatus) {
        case "READ_UNKNOWN":
        case 0:
            message.readStatus = 0;
            break;
        case "UNREAD":
        case 1:
            message.readStatus = 1;
            break;
        case "READ":
        case 2:
            message.readStatus = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a MsgData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MsgData
     * @static
     * @param {MsgData} message MsgData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MsgData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.packageGuid = "";
            object.version = 0;
            object.fromGuid = "";
            object.targetGuid = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.time = options.longs === String ? "0" : 0;
            object.data = "";
            object.sessionType = options.enums === String ? "SESSION_UNKNOWN" : 0;
            object.contentType = options.enums === String ? "CONTENT_UNKNOWN" : 0;
            object.readyState = options.enums === String ? "UNKNOWN" : 0;
            object.sender = options.enums === String ? "SENDER_UNKNOWN" : 0;
            object.extension = "";
            object.actions = "";
            object.readStatus = options.enums === String ? "READ_UNKNOWN" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.packageGuid != null && message.hasOwnProperty("packageGuid"))
            object.packageGuid = message.packageGuid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            object.targetGuid = message.targetGuid;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.sessionType != null && message.hasOwnProperty("sessionType"))
            object.sessionType = options.enums === String ? $root.MsgData.SessionType[message.sessionType] : message.sessionType;
        if (message.contentType != null && message.hasOwnProperty("contentType"))
            object.contentType = options.enums === String ? $root.MsgData.ContentType[message.contentType] : message.contentType;
        if (message.readyState != null && message.hasOwnProperty("readyState"))
            object.readyState = options.enums === String ? $root.MsgData.ReadyState[message.readyState] : message.readyState;
        if (message.sender != null && message.hasOwnProperty("sender"))
            object.sender = options.enums === String ? $root.MsgData.Sender[message.sender] : message.sender;
        if (message.extension != null && message.hasOwnProperty("extension"))
            object.extension = message.extension;
        if (message.actions != null && message.hasOwnProperty("actions"))
            object.actions = message.actions;
        if (message.readStatus != null && message.hasOwnProperty("readStatus"))
            object.readStatus = options.enums === String ? $root.MsgData.ReadStatus[message.readStatus] : message.readStatus;
        return object;
    };

    /**
     * Converts this MsgData to JSON.
     * @function toJSON
     * @memberof MsgData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MsgData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * SessionType enum.
     * @name MsgData.SessionType
     * @enum {string}
     * @property {number} SESSION_UNKNOWN=0 SESSION_UNKNOWN value
     * @property {number} P2P=1 P2P value
     * @property {number} SYSTEM=2 SYSTEM value
     */
    MsgData.SessionType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SESSION_UNKNOWN"] = 0;
        values[valuesById[1] = "P2P"] = 1;
        values[valuesById[2] = "SYSTEM"] = 2;
        return values;
    })();

    /**
     * ContentType enum.
     * @name MsgData.ContentType
     * @enum {string}
     * @property {number} CONTENT_UNKNOWN=0 CONTENT_UNKNOWN value
     * @property {number} TEXT=1 TEXT value
     * @property {number} IMAGE=2 IMAGE value
     * @property {number} ACC=3 ACC value
     * @property {number} HOUSE=4 HOUSE value
     * @property {number} ARTICLE=5 ARTICLE value
     * @property {number} ACTIONS=6 ACTIONS value
     * @property {number} CARD=7 CARD value
     * @property {number} CARDTEXT=8 CARDTEXT value
     */
    MsgData.ContentType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CONTENT_UNKNOWN"] = 0;
        values[valuesById[1] = "TEXT"] = 1;
        values[valuesById[2] = "IMAGE"] = 2;
        values[valuesById[3] = "ACC"] = 3;
        values[valuesById[4] = "HOUSE"] = 4;
        values[valuesById[5] = "ARTICLE"] = 5;
        values[valuesById[6] = "ACTIONS"] = 6;
        values[valuesById[7] = "CARD"] = 7;
        values[valuesById[8] = "CARDTEXT"] = 8;
        return values;
    })();

    /**
     * ReadyState enum.
     * @name MsgData.ReadyState
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} READY=1 READY value
     * @property {number} NOT_READY=2 NOT_READY value
     */
    MsgData.ReadyState = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "READY"] = 1;
        values[valuesById[2] = "NOT_READY"] = 2;
        return values;
    })();

    /**
     * Sender enum.
     * @name MsgData.Sender
     * @enum {string}
     * @property {number} SENDER_UNKNOWN=0 SENDER_UNKNOWN value
     * @property {number} TO_AGENT=1 TO_AGENT value
     * @property {number} TO_CUSTOMER=2 TO_CUSTOMER value
     */
    MsgData.Sender = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SENDER_UNKNOWN"] = 0;
        values[valuesById[1] = "TO_AGENT"] = 1;
        values[valuesById[2] = "TO_CUSTOMER"] = 2;
        return values;
    })();

    /**
     * ReadStatus enum.
     * @name MsgData.ReadStatus
     * @enum {string}
     * @property {number} READ_UNKNOWN=0 READ_UNKNOWN value
     * @property {number} UNREAD=1 UNREAD value
     * @property {number} READ=2 READ value
     */
    MsgData.ReadStatus = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "READ_UNKNOWN"] = 0;
        values[valuesById[1] = "UNREAD"] = 1;
        values[valuesById[2] = "READ"] = 2;
        return values;
    })();

    return MsgData;
})();

module.exports = $root;
